import Header from "../components/Header/Header";
import yay from "../assets/7.jpg";
import Footer from "../components/Footer/Footer";
import CookieConsent from "../components/CookieConsent/CookieConsent";
import Masthead from "../components/Masthead/Masthead";

const About = () => {
  return (
    <>
      <CookieConsent />
      <Header />
      <section className="relative flex w-full md:h-256 h-160 overflow-hidden bg-cyan-400">
        <img src={yay} className="min-w-full object-cover" alt="" />
        <Masthead title="About ZeroPA" subtitle="An alternative lender" />
      </section>

      <section className="text-gray-600 body-font">
        <div className="container px-5 py-24 mx-auto flex flex-wrap">
          <h2 className="sm:text-3xl text-1xl text-gray-900 font-medium title-font mb-2 md:w-2/5 leading-none">
            Disrupting, educating &amp; lending
          </h2>
          <div className="md:w-3/5 md:pl-6">
            <p className="leading-relaxed text-base">
              ZeroPA is a social impact lender that offers financial education
              and tools and crucially interest free loans to the financially
              disadvantaged and vulnerable with a commercial return to lenders
              and investors.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default About;
